import { gql } from 'apollo-angular';
import { Person } from '../../../../interfaces/person';

type PersonSearchResults = {
  searchPeopleInGroup: Person[];
};
type PersonSearchVariables = {
  query: string;
  group_id: string;
};
export const SEARCH_FOR_PERSON = gql<
  PersonSearchResults,
  PersonSearchVariables
>`
  query searchPeopleInGroup($query: String!, $group_id: String!) {
    searchPeopleInGroup(query: $query, group_id: $group_id) {
      id
      name
    }
  }
`;
